import http from '../utils/http';
import i18n from '@/main';

const baseUrl = '/usuarios';

export default {
    getAll({ page = 0, filter = '', order = null }) {
        return http.get({
            url: baseUrl + `/?page=${page}&filter=${filter}&order=${order}`,
            lockScreen: false,
            lockMessage: i18n.t('mensagens.sistema.buscandoUsuarios')
        });
    },

    save(user) {
        return http.post({
            url: baseUrl,
            data: { ...user },
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.adicionandoUsuario')
        });
    },

    edit(user, id) {
        return http.post({
            url: baseUrl + `/${id}`,
            data: { ...user },
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.salvandoUsuarioAtualizado')
        });
    },

    updateUserLocale(userId, newLocale) {
        return http.put({
            url: `${baseUrl}/${userId}/locale`,
            data: newLocale,
            lockScreen: false
        });
    },

    changeEnabled(id, enabled) {
        return http.post({
            url: baseUrl + `/${id}/${enabled}`,
            data: {},
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.atualizandoStatusDoUsuario')
        });
    },

    getbyCpf(cpf) {
        return http.get({
            url: baseUrl + `/cpf/${cpf}`,
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.buscandoUsuario')
        });
    },

    getbyEmail(email) {
        return http.get({
            url: baseUrl + `/por-email/${email}`,
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.buscandoUsuario')
        });
    },

    sendEmail(id) {
        return http.get({
            url: baseUrl + `/send-email/${id}`,
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.enviandoEmail')
        });
    },

    getUserNameById(id) {
        return http.get({
            url: baseUrl + `/nome/${id}`,
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.buscandoNomeDoUsuario')
        });
    },

    buscaTodosSemPaginacaoPorGrupo(name) {
        return http.get({
            url: baseUrl + `/usuarios-todos-grupo/?query=${name}`,
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.buscandoUsuarios')
        });
    },

    buscaTodosSemPaginacao(name) {
        return http.get({
            url: baseUrl + `/usuarios-todos/?query=${name}`,
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.buscandoUsuarios')
        });
    },

    getUserNameEmpresa(id, idEmpresa) {
        return http.get({
            url: baseUrl + `/nome-empresa/${id}/${idEmpresa}`,
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.buscandoDadosDoUsuario')
        });
    },

    getGroups(lockScreen = false) {
        return http.get({
            url: baseUrl + `/empresas`,
            lockScreen: false,
            lockMessage: i18n.t('mensagens.sistema.buscandoDadosDasEmpresas')
        });
    },

    getUsersByGroup(filtros) {
        return http.post({
            url: baseUrl + '/por-empresas',
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.buscandoUsuarios'),
            data: filtros
        });
    },

    buscarEmpresasSubEmpresas(filtro) {
        return http.get({
            url: baseUrl + `/empresas-sub-empresas/?filter=${filtro}`,
            lockScreen: false,
            lockMessage: i18n.t('mensagens.sistema.buscandoEmpresas')
        });
    },

    buscarPerfis() {
        return http.get({
            url: baseUrl + '/perfis',
            lockScreen: false,
            lockMessage: i18n.t('mensagens.sistema.buscandoRolesDeOperacao')
        });
    },

    exportUsersByGroup(filtros) {
        const fileLink = document.createElement('a');
        try {
            return http
                .post({
                    url: baseUrl + '/por-empresas/xlsx',
                    config: {
                        responseType: 'blob'
                    },
                    lockScreen: true,
                    lockMessage: i18n.t('mensagens.sistema.preparandoDadosParaDownload'),
                    data: filtros
                })
                .then(response => {
                    if (response.status === 200) {
                        fileLink.href = window.URL.createObjectURL(
                            new Blob([response.data])
                        );
                        const filenameRegex =
                            /filename=['"]?([^;\r\n"']*)['"]?;?/;
                        const contentDisposition =
                            response.headers['content-disposition'];

                        fileLink.setAttribute(
                            'download',
                            filenameRegex.exec(contentDisposition)[1]
                        );
                        document.body.appendChild(fileLink);

                        fileLink.click();
                        return Promise.resolve();
                    }
                });
        } catch (error) {
            return Promise.reject(error);
        } finally {
            fileLink.remove();
        }
    },
    
    buscaPermissaoUsuario(idGrupo) {
        return http.post({
            url: baseUrl + `/${idGrupo}/usuarios`,
            lockScreen: false
        });
    },

    atualizarGrupoSelecionado(nomeGrupo, refreshToken) {
        return http.post({
            url: `${baseUrl}/atualizar-grupo`,
            data: { nomeGrupo, refreshToken },
            lockScreen: true
        });
    }
    
};
